/**
 * Portfolio listing page.
 */
import PageShell from "../components/ui/PageShell";
import GlassPanel from "../components/ui/GlassPanel";

export default function Portfolio() {
  return (
    <PageShell>
      <div className="space-y-10">
        <GlassPanel>
          <div className="space-y-6">
            <p className="text-lg leading-relaxed text-white/90">
              Strategy Game
              <br />
              (Planning Phase)
            </p>

            <hr className="border-white/10" />

            <div className="space-y-3">
              <h2 className="text-base font-bold text-white">About:</h2>
              <p className="leading-relaxed text-white/90">
                Inspired by Creative Assembly&apos;s Empire Total War video game and Albert
                Lamorisse&apos;s Risk board game. Play alone or with others as 1-8 players manage
                their colonies and compete against AI and eachother for resources, territory, and
                influence. Enjoy grand strategy across a campaign map and real-time tactical battles
                along 5 continents: North America, South America, Europe, Asia, Africa, and Oceania.
                Play as one of several different world powers in the 18th century during the age of
                exploration, colonization, and enlightenment. Manage your colony&apos;s economy,
                diplomacy, and military to bridge peace, form allies, and build up your settlements or
                beat the drums of war and expand your borders. Plan your moves carefully. Every
                decision you make says something about you. what kind of leader are you? Good luck
                commander!
              </p>
            </div>

            <div className="space-y-3">
              <h2 className="text-base font-bold text-white">Platform:</h2>
              <p className="leading-relaxed text-white/90">Windows</p>
            </div>

            <div className="space-y-3">
              <h2 className="text-base font-bold text-white">Timeline:</h2>
              <p className="leading-relaxed text-white/90">TBA</p>
            </div>
          </div>
        </GlassPanel>

        <GlassPanel>
          <div className="space-y-6">
            <p className="text-lg leading-relaxed text-white/90">
              Mystery Novel
              <br />
              (World Building Phase)
            </p>

            <hr className="border-white/10" />

            <div className="space-y-3">
              <h2 className="text-base font-bold text-white">About:</h2>
              <p className="leading-relaxed text-white/90">
                A detective is sent to investigate the death of 2 foreign exchange students on a
                remote island north of Scandinavia called Bear Island. Uncovering a web of secrets
                and conspiracies they are led to question everything they thought they knew about the
                case, the island, and even themselves. Prepare yourselves for a psychological thriller
                full of twists and turns that will keep you guessing until the very end.
              </p>
            </div>

            <div className="space-y-3">
              <h2 className="text-base font-bold text-white">Platform:</h2>
              <p className="leading-relaxed text-white/90">E-Book (Kindle)</p>
            </div>

            <div className="space-y-3">
              <h2 className="text-base font-bold text-white">Timeline:</h2>
              <p className="leading-relaxed text-white/90">TBA</p>
            </div>
          </div>
        </GlassPanel>
      </div>
    </PageShell>
  );
}
